module.exports = require('./helpers/bundle-url').getBundleURL('sdbCj') + "Terms of Service.b9f31342.pdf";